 import Vue from 'vue'
 import VueRouter from 'vue-router'
 import Home from '../views/Home.vue'



Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/aboutUs',
    name: 'home',
    component: Home,
  },
  {
    path: '/features',
    name: 'home',
    component: Home,
  },
  {
    path: '/channels',
    name: 'home',
    component: Home,
  },
  {
    path: '/blog',
    name: 'home',
    component: Home,
  },

  {
    path: '/contact',
    name: 'home',
    component: Home,
  },

  {
    path: '/adept',
    name: 'home',
    component: Home,
  },

  {
    path: '/corporate_payment',
    name: 'home',
    component: Home,
  },
  {
    path: '/ussd_cashout',
    name: 'home',
    component: Home,
  },
  {
    path: '/bank_transfer',
    name: 'home',
    component: Home,
  },
  {
    path: '/ussd_payment',
    name: 'home',
    component: Home,
  },

  {
    path: '/feedbacks',
    name: 'home',
    component: Home,
  },


  {
    path: '/partners',
    name: 'home',
    component: Home,
  },

  {
    path: '/blog/:id',
    name: 'blogDetail',
    component: () => import('../views/BlogDetail.vue'),
  },
  {
    path: '*',
    name: 'Error404',
    component: () => import ('../views/Error404.vue'),
  },
]

const router = new VueRouter({
  routes
})

export default router
